'use strict';

var Swiper = require('swiper').Swiper;
var Navigation = require('swiper/modules').Navigation;


var scrollAnimate = require("base/components/scrollAnimate");

let headerZindex = null;

function initAccordionFooterListener() {
    $('.footer-item').on('click', function() {
        $(this).toggleClass('active');
        $(this).find('.footer-title').toggleClass('active');
    });
}

function initSwiper() {
    new Swiper('#footer-pdf-swiper', {
        // Optional parameters
        modules: [Navigation],
        direction: 'horizontal',
        loop: false,
        autoHeight: true,

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
    });
}

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.email-signup-message').length === 0) {
        $('body').append(
            '<div class="email-signup-message"></div>'
        );
    }
    $('.email-signup-message')
        .append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.email-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

function openSidebar () {
    headerZindex = $('header').css('z-index');
    $('header').css('z-index', 999);    
    $('.floating-menu').addClass('open');
}

function closeSidebar () {
    if(headerZindex !== null) {
        $('header').css('z-index', headerZindex);
    }
    $('.floating-menu').removeClass('open');
}

function hasClickedOutsideSidebar (event) {
    var target = $(event.target);
    var floatingSidebarButton = $('.floating-button__toggle');
    var sidebar = $('.floating-menu');
    return !target.closest(floatingSidebarButton).length && !target.closest(sidebar).length
}

function initSidebar () {
    var floatingSidebarButton = $('.floating-button__toggle');
    
    floatingSidebarButton.on('click', function() {
        openSidebar()
    });

    $(document).on('click', function(event) {
        if (hasClickedOutsideSidebar(event)) {
            closeSidebar();
        }
    });

    $('.close-promotions-sidebar').on('click', function() {
        closeSidebar()
    })

    if ($('.sidebar-item').length === 0) {
        $('.floating-button').addClass('d-none')
        $('.floating-menu').addClass('d-none')
    }
}

module.exports = {
    init : function () {
        $('.back-to-top').click(function () {
            scrollAnimate();
        });
        initSwiper();
        initAccordionFooterListener();
        initSidebar();
    }
};
